<template>
  <v-row justify="center">
    <a @click.stop="handleReportList(reportReviewList.id)" class="text-decoration-underline">
      {{ reportReviewList.report_number === 0 ? '' : reportReviewList.report_number }}
    </a>

    <v-dialog v-model="dialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span>Reported Review List</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="reportList"
            :loading="loading"
            item-key="id"
            class="full-width"
            max-height="50px"
            hide-default-footer
          >
            <v-progress-linear color="blue" indeterminate />
            <template v-if="reportList.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" :style="{ cursor: 'pointer' }">
                  <td class="text-center">{{ items.indexOf(item) + 1 }}</td>
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">{{ item.review_id }}</td>
                  <td class="text-left" v-html="contact(item)"></td>
                  <td class="text-center">{{ item.removal_reason }}</td>
                  <td class="text-center">
                    {{ dateTime.formateDateTimeForDisplay(item.created_at) }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog()"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import reviewsService from '../services/reviews';
import dateTime from '../utils/dateTime';

export default Vue.extend({
  name: 'ReportedReviewListDialog',
  props: ['reportReviewList'],
  data: () => ({
    dialog: false,
    loading: false,
    reportId: 0,
    reportList: [],
    headers: [
      {
        text: 'No.',
        align: 'center',
        value: 'id',
        width: 60,
        sortable: false,
      },
      {
        text: 'Report Id',
        align: 'center',
        value: 'report_id',
        width: 90,
        sortable: false,
      },
      {
        text: 'Review Id',
        align: 'center',
        value: 'review_id',
        width: 150,
        sortable: false,
      },
      {
        text: 'Reported by',
        align: 'center',
        value: 'reported_by',
        width: 200,
        sortable: false,
      },
      {
        text: 'Removal Reason',
        align: 'center',
        value: 'removal_reason',
        width: 250,
        sortable: false,
      },
      {
        text: 'Reported At',
        align: 'center',
        value: 'reported_at',
        width: 120,
        sortable: false,
      },
    ],
  }),
  watch: {},
  computed: {
    dateTime() {
      return dateTime;
    },
  },
  methods: {
    contact(item) {
      let content = '';
      if (item.user.email) content += '<br>Email: ' + item.user.email;
      if (item.user.support_pin) content += `<br>Support Pin: <strong>${item.user.support_pin}</strong>`;
      return content;
    },
    handleReportList(item) {
      this.dialog = true;
      this.reportId = item;
      this.getReportList().then((data) => {
        this.reportList = data.items;
      });
    },
    closeDialog() {
      this.dialog = false;
    },
    getReportList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        reviewsService
          .getReviewReport(this.reportId)
          .then((res) => {
            const items = res.data;
            resolve({ items });
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
  mounted() {},
});
</script>
